import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataStateChangeEventArgs, GridComponent, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GlobalComponent } from 'src/app/global/global.component';
import { functionpermission, GetLovBO, saveLovBO } from './lov.model';
import { LovService } from './lov.service';
import { LovDateService } from './lovdate.service';

@Component({
  selector: 'app-lov',
  templateUrl: './lov.component.html',
  styleUrls: ['./lov.component.scss']
})
export class LovComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  saveLov: saveLovBO = new saveLovBO();
  FilterBo: GetLovBO = new GetLovBO();

  getListDropdownList:any=[];
  LovForm: FormGroup;
  LovType: string;
  public filterSettings: object;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  initialPage: PageSettingsModel;
  selectListType:string;
  @ViewChild('gridLov') public gridLov: GridComponent;

  public GridList: Observable<DataStateChangeEventArgs>;
  isSaveorUpdateBoolean:boolean=false;
  constructor(public getLovService: LovDateService,
    public global: GlobalComponent, private formBuilder: FormBuilder, 
    public LService: LovService, public toasterService: ToastrService,) {
    this.LovForm = this.formBuilder.group({
      LovCode: [' ', Validators.required],
      LovName: [' ', Validators.required],
      LovValue: [' '],
      Orderby: [' ', Validators.required],

    });
    this.global.checkforlogout();
    this.GridList = getLovService;
  }
  fp:functionpermission=new functionpermission()
  ngOnInit(): void {
    this.filterSettings = {
      type: 'Menu',
    };
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
    this.ListDropDown();
    this.getpermission()
  }

  getpermission() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId!=null&&this.global.globalAgencyId!=undefined&&this.global.globalAgencyId!='')) {
    let params = new URLSearchParams();
    params.append("pagecode", "Lov");
    params.append("roleId", this.global.roleId);
    params.append("agencyId", this.global.globalAgencyId)
    this.getLovService.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (data != null) {
        this.fp = data;
      }
      else {
        this.fp = new functionpermission();
      }
    },
      (err: HttpErrorResponse) => {
        this.fp = new functionpermission();
      })
  }
}
  //.........................................CreateLocationList.............................................
  CreateorUpdateLov(data) {
    this.LovType = data;
    if (this.LovType == 'CreatelovModal') {
      this.saveLov = new saveLovBO();
      this.LovForm.reset();
    }
  }
  //...........................................getDetails..........................................
  getDetails(saveBos: saveLovBO) {
    this.saveLov = JSON.parse(JSON.stringify(saveBos));
  }
  //.........................................Refresh.............................................
  clearLov(type: string) {
    this.LovType = null;
    this.saveLov = new saveLovBO();
    this.LovForm.reset();
    if (type == "refresh") {
      this.getLovFilter();
    }
  }
    // ................................................dataChangeLov..............................................
    public dataChangeLov(Lov): void {
      let val = (Lov.action.requestType).toString();
      if (val != "filterchoicerequest") {
        if ((Lov.sorted || []).length) {
          this.FilterBo.orderColumn = Lov.sorted[0].name;
          this.FilterBo.orderType = Lov.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
        }
      }
      if (val == "filtering" && Lov.action.action != "clearFilter") {
        this.FilterBo.value = Lov.action.currentFilterObject.value;
        this.FilterBo.field = Lov.action.currentFilterObject.field;
        this.FilterBo.matchCase = Lov.action.currentFilterObject.matchCase;
        this.FilterBo.operator = Lov.action.currentFilterObject.operator;
      }
      else {
        if (val == "filtering" && Lov.action.action == "clearFilter") {
          this.FilterBo.field = "LovCode";
          this.FilterBo.matchCase = false;
          this.FilterBo.operator = "contains";
          this.FilterBo.value = "";
          this.FilterBo.type = "string";
        }
      }
      this.getLovFilter();
      if (val == "paging" && Lov.action.name == "actionBegin") {
     
      }
    }
    //.........................................onActionLov.....................................................
    public onActionLov(Lov) {
      this.FilterBo.currentpageno = this.gridLov.pagerModule.pagerObj.currentPage;
      this.FilterBo.pageitem = this.gridLov.pagerModule.pagerObj.pageSize;
      if (Lov.name == "actionBegin" && Lov.requestType == "filterbeforeopen") {
        this.FilterBo.type = Lov.columnType
      }
    }
  //.........................................getLovFilter.............................................
  getLovFilter() {
     this.FilterBo.listId=this.selectListType;
    this.getLovService.execute(this.FilterBo);
    let count = 0;
    this.GridList.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      count = count + 1;
      if (data != null && data.result.length > 15) {
        this.gridLov.height = '500';
      }
      else {
        this.gridLov.height = 'auto';
      }
    })
  }
  //.........................................SaveOrUpdateLov.............................................
  SaveOrUpdateLov() {
    this.isSaveorUpdateBoolean=true;
    let saveLov: saveLovBO = JSON.parse(JSON.stringify(this.saveLov));
    saveLov.id = this.saveLov.id;
    saveLov.orderby =parseInt(this.saveLov.orderby.toString());
    saveLov.listId=this.selectListType;
    this.LService.SaveOrUpdateLov(saveLov).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.isSaveorUpdateBoolean=false;
      document.getElementById('openLovModal').click();
      if (data) {
        if (this.LovType == 'CreatelovModal') {
          document.getElementById('openLovModal').click();
          setTimeout(() => {
            this.toasterService.clear();
          }, 8000);

        }
        else if (this.LovType == 'UpdatelovModal') {
          this.toasterService.success('Lov updated successfully!');
          setTimeout(() => {
            this.toasterService.clear();
          }, 8000);
        }
        document.getElementById('openLovModal').click();
        this.LovForm.reset();
        this.getLovFilter();
      }
    }, (err: any) => {
      this.isSaveorUpdateBoolean=false;
      if (err) {
        this.toasterService.error(err, 'Error'), 8000;
      }
    })
  }
  //.....................................showLovColumns....................................
  showLovColumns() {
    this.gridLov.columnChooserModule.openColumnChooser(200, 50);
  }
  //..........................................DeleteLov...........................................................
  DeleteLov() {
    this.LService.DeleteLov(this.saveLov.id).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.toasterService.success('Lov deleted successfully!');
      setTimeout(() => {
        this.toasterService.clear();
      }, 8000);
      document.getElementById('closeLovModal').click();
      this.getLovFilter();
    }, (err: any) => {
      if (err) {
        this.toasterService.error(err, 'Error'), 8000;
      }
    });
  }
  //....................................ListDropDown.............................................
  ListDropDown() {
    this.LService.ListDropDown().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.getListDropdownList=data;
    }, (err: any) => {
      if (err) {
        this.toasterService.error(err, 'Error'), 8000;
      }
    });
  }
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}
